// import { unionBy } from 'lodash';
import { appConstants } from '../constants/app';
// import { defaultThemes } from '../config';

const initialState = {
  globalSettings: {
    basePath: '',
    staticPath: '',
    countries: [],
    sources: [],
    timezones: [],
    currencies: [],
    languages: [],
    themes: [],
    parking: []
  },

  settings: {
    activeItem: '',
    stream: [],
    site: [],
    offer: {},
  },

  socials: {},
  headerCurrency: 0,
};

// const filterThemes = (prevThemes, nextThemes, newTheme) => {
//   return unionBy(prevThemes, nextThemes, newTheme, 'id');
// };

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case appConstants.SET_GLOBAL_SETTINGS_SUCCESS:

      // const themes = filterThemes(
      //   action.settings.themes,
      //   state.globalSettings.themes,
      //   [{ id: 3, name: 'KMA'}],
      // );
      return {
        ...state,
        globalSettings: {
          ...state.globalSettings,
          ...action.settings,
          // themes,
        },
      };
    case appConstants.SET_SITE_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          site: action.settings,
        },
      };

    case appConstants.SET_OFFERS_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: {
          ...state.settings,
          offer: action.settings,
        },
      };

    case appConstants.SET_SOCIALS_SUCCESS:
      return {
        ...state,
        socials: action.socials,
      };
    case appConstants.SET_HEADER_CURRENCY:
      return {
        ...state,
        headerCurrency: action.active,
      };
    case appConstants.SET_ACTIVE_ITEM:
      return {
        ...state,
        settings: {
          ...state.settings,
          activeItem: action.item
        },
      };
    default:
      return state;
  }
};
